module.exports = __webpack_public_path__ + "static/media/pricingV3.e8db38b6.mp4";